import { supabase } from '../lib/supabase';
import { logger } from '../utils/logger';

/**
 * Get all prompts for a feature group
 */
export const getPrompts = async (featureGroupId) => {
  try {
    const { data, error } = await supabase
      .from('prompts')
      .select('*')
      .eq('feature_group_id', featureGroupId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    logger.error('Error fetching prompts:', error);
    throw error;
  }
};

/**
 * Get a single prompt by ID
 */
export const getPromptById = async (promptId) => {
  try {
    const { data, error } = await supabase
      .from('prompts')
      .select('*')
      .eq('id', promptId)
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    logger.error('Error fetching prompt:', error);
    throw error;
  }
};

/**
 * Create a new prompt
 */
export const createPrompt = async (promptData) => {
  try {
    const { data, error } = await supabase
      .from('prompts')
      .insert([{
        feature_group_id: promptData.feature_group_id,
        name: promptData.name.trim(),
        prompt_text: promptData.prompt_text,
        scope: promptData.scope || 'Feature Map',
        live: promptData.live || false,
        context_data: promptData.context_data || []
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    logger.error('Error creating prompt:', error);
    throw error;
  }
};

/**
 * Update an existing prompt
 */
export const updatePrompt = async (promptId, promptData) => {
  try {
    const { data, error } = await supabase
      .from('prompts')
      .update({
        name: promptData.name.trim(),
        prompt_text: promptData.prompt_text,
        scope: promptData.scope || 'Feature Map',
        live: promptData.live || false,
        context_data: promptData.context_data || [],
        updated_at: new Date().toISOString()
      })
      .eq('id', promptId)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    logger.error('Error updating prompt:', error);
    throw error;
  }
};

/**
 * Delete a prompt
 */
export const deletePrompt = async (promptId) => {
  try {
    const { error } = await supabase
      .from('prompts')
      .delete()
      .eq('id', promptId);

    if (error) throw error;
  } catch (error) {
    logger.error('Error deleting prompt:', error);
    throw error;
  }
};

